import { useState, useEffect } from "react";
import { Form, Input, Row, Col, Select, DatePicker } from "antd";

import lookupAPI from "../../services/candidateLookupService";
import moment from "moment";
import { recordError } from "../../utils/logService";

import { util } from '@seims/shared';

const Qualification = ({ data }) => {
  const [qualifications, setQualifications] = useState([]);
  const [qualificationData, setQualificationData] = useState({});

  const formItemLayout = {
    labelCol: {
      span: 12,
    },
    wrapperCol: {
      span: 18,
    },
    layout: "vertical",
  };

  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "QualificationForm";

  useEffect(() => {
    getQualifications();
  }, []);

  useEffect(() => {
    prePopilateQualifs();
  }, [qualifications, qualificationData]);

  const prePopilateQualifs = () => {
    try {
      if (!util.isEmpty(data)) {
        const selectedQualification = qualifications.find(
          (record) => record.key === data.highestQualification
        );

        form.setFieldsValue({
          id: data.id,
          fieldOfStudy: data.fieldOfStudy,
          highestQualification: selectedQualification,
          institutionOfStudy: data.institutionOfStudy,
          grade12CompletionYear: data?.grade12CompletionYear ? moment(data.grade12CompletionYear, "YYYY") : null,

          //!SUBJECTS SHOULD BE MANAGED LIKE CONTRIBUTIONS
          //!ONE SHOULD HAVE OT LOOP THE ARRAYS AND MAP TO CONRRESPONDING CONTROL
          subject1: data.subjects.length > 0 ? data.subjects[0] : "",
          subject2: data.subjects.length > 1 ? data.subjects[1] : "",
          subject3: data.subjects.length > 2 ? data.subjects[2] : "",
        });
        setQualificationData(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getQualifications = async () => {
    try {
      const response = await lookupAPI.getQualifications();
      if (response) {
        const { data } = response;
        setQualifications(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  return (
    <>
      <h1 className="center-align">Highest Qualification</h1>
      <p className="sub-title center-align">View Highest Qualification</p>
      <br />
      <Form {...formItemLayout} name={formName} form={form} disabled>
        <Row>
          <Col xs={24} md={8} lg={7}>
            <Form.Item
              name="highestQualification"
              label="Qualification"
              rules={[{ required: false }]}
            >
              <Select>
                {qualifications.map((qualification) => (
                  <Option key={qualification.key} value={qualification.value}>
                    {qualification.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={8} lg={7}>
            <Form.Item
              name="fieldOfStudy"
              label="Field of Study"
              rules={[{ required: true, message: "Enter the field of Study" }]}
            >
              <Input name="fieldOfStudy" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8} lg={7}>
            <Form.Item
              name="institutionOfStudy"
              label="Institution of Study"
              rules={[{ required: false }]}
            >
              <Input name="institutionOfStudy" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <p>Major Subjects (Max 3)</p>
        </Row>
        <Row>
          <Col xs={24} md={8} lg={7}>
            <Form.Item name="subject1" label="Subject 1">
              <Input name="subject1" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8} lg={7}>
            <Form.Item name="subject2" label="Subject 2">
              <Input name="subject2" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8} lg={7}>
            <Form.Item name="subject3" label="Subject 3">
              <Input name="subject3" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={20}>
            <Form.Item
              name="grade12CompletionYear"
              label="Year Grade 12 obtained"
              rules={[{ required: false }]}
            >
              <DatePicker picker="year" placeholder="" />
            </Form.Item>
          </Col>
          <Col span={3}>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default Qualification;
